import Cookies from 'js-cookie'

export const userMixin = {
  computed: {
    cvAccountToken () {
      let _t = Cookies.get('_t')
      if (_t) {
        let tokenPayload = _t && JSON.parse(window.atob(_t.split('.')[1]))
        return tokenPayload.User.c_t
      }
    }
  }
}